var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLikes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100.08 92.61",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73 0c1.41 0 2.92.08 4.53.23 9.81.94 21.14 9.78 22.53 26.7v5.64c-1.25 15.72-13 35-46.87 59a5.48 5.48 0 01-6.35 0C13 67.57 1.25 48.29 0 32.57v-5.64C1.38 10 12.72 1.17 22.52.23 24.13.08 25.64 0 27.05 0 38.38 0 43.82 4.82 50 12.11 56.26 4.82 61.69 0 73 0",
    fill: "#878789",
    "data-name": "Capa 1"
  }))));
}

export default SvgLikes;